<template>
  <v-card class="com-pc-card">
    <v-row class="com-pc-card-header">
      <span class="com-pc-card-title" style="margin-right:12px;">{{
        text.registrationPoint
      }}</span>
      <v-tooltip right max-width="300">
        <template v-slot:activator="{ on }">
          <v-icon color="white" light v-on="on">help_outline</v-icon>
        </template>
        <span>{{ text.help }}</span>
      </v-tooltip>
    </v-row>
    <v-col class="com-pc-card-contents pa-0">
      <v-simple-table light>
        <thead>
          <tr>
            <th class="sub-head vc-th-point">{{ text.pointName }}</th>
            <th class="sub-head vc-th-location">{{ text.location }}</th>
            <th class="sub-head vc-th-riskInfo">{{ text.riskInfo }}</th>
            <th class="sub-head vc-th-icon">{{ text.icon }}</th>
            <th class="sub-head vc-th-delete">{{ text.delete }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, idx) in pointRegist"
            :key="idx"
            class="point-data"
            @click="selectPoint(idx)"
          >
            <td>
              <v-text-field
                class="vc-item-name"
                :rules="rules"
                :maxlength="maxLength"
                :disabled="editFlag !== 0 && editLocationMode !== 1"
                clear-icon="cancel"
                v-model="item.name"
                @change="changePointName(idx)"
              ></v-text-field>
            </td>
            <td v-if="item.address" class="">
              <span>{{ item.address }}</span>
            </td>
            <td v-if="!item.address">
              <span>
                <v-btn
                  outlined
                  small
                  :loading="
                    editFlag !== 0 &&
                      editLocationMode !== 1 &&
                      idx === registPointNum
                  "
                  :disabled="
                    editFlag !== 0 &&
                      editLocationMode !== 1 &&
                      idx !== registPointNum
                  "
                  color="success"
                  class="vc-btn"
                  @click="regist(idx, item.name, editFlag)"
                >
                  <span>{{ text.registration }}</span>
                </v-btn>
              </span>
            </td>
            <td v-if="isLoading(idx)" colspan="2">
              <v-row class="vc-td-loading">
                <div v-if="item.address" class="vc-td-item-loading">
                  <!-- <v-progress-circular
                    :rotate="5"
                    :size="50"
                    :value="progressValue"
                    color="teal"
                  >
                    {{ progressValue }}%
                  </v-progress-circular> -->
                  <!-- <v-progress-linear
                    :value="progressValue"
                    height="25"
                    color="cyan lighten-2"
                  >
                    {{ progressValue }}%</v-progress-linear
                  > -->
                </div>
                <!-- <div class="vc-td-item-tooltip pl-2 pr-0">
                  <v-tooltip bottom max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        color="teal"
                        class="ml-2"
                        fab
                        >format_list_bulleted</v-icon
                      >
                    </template>
                    <span>
                      <v-icon v-if="registPointState >= 1" color="green"
                        >check_box</v-icon
                      >
                      <v-icon v-else color="green"
                        >check_box_outline_blank</v-icon
                      >
                      {{ text.rpStateName1 }}
                    </span>
                    <br />
                    <span>
                      <v-icon v-if="registPointState >= 2" color="green"
                        >check_box</v-icon
                      >
                      <v-icon v-else color="green"
                        >check_box_outline_blank</v-icon
                      >
                      {{ text.rpStateName2 }}
                    </span>
                    <br />
                    <span>
                      <v-icon v-if="registPointState >= 3" color="green"
                        >check_box</v-icon
                      >
                      <v-icon v-else color="green"
                        >check_box_outline_blank</v-icon
                      >
                      {{ text.rpStateName3 }}
                    </span>
                    <br />
                    <span>
                      <v-icon v-if="registPointState >= 4" color="green"
                        >check_box</v-icon
                      >
                      <v-icon v-else color="green"
                        >check_box_outline_blank</v-icon
                      >
                      {{ text.rpStateName4 }}
                    </span>
                  </v-tooltip>
                </div> -->
                <div class="vc-td-item-cancel">
                  <v-btn
                    class="ml-4"
                    small
                    outlined
                    color="success"
                    @click="registCancel(idx)"
                    >{{ text.cancel }}</v-btn
                  >
                </div>
              </v-row>
            </td>
            <td v-if="!isLoading(idx)">
              <span v-if="item.address">
                <v-btn
                  outlined
                  small
                  color="success"
                  class="vc-btn"
                  :loading="
                    editFlag !== 0 &&
                      editLocationMode !== 1 &&
                      idx === registPointNum
                  "
                  :disabled="editFlag !== 0 && editLocationMode !== 1"
                  @click="collectionRisk(idx, item.risk)"
                >
                  <span v-if="item.risk">{{ text.uppdate }}</span>
                  <span v-else>{{ text.collection }}</span>
                </v-btn>
              </span>
            </td>
            <td v-if="!isLoading(idx)">
              <span v-if="item.address">
                <!-- <v-btn
                  fab
                  outlined
                  x-small
                  color="success"
                  :disabled="editFlag !== 0 && editLocationMode !== 1"
                  @click="deletePoint(idx)"
                >
                  <v-icon small>clear</v-icon>
                </v-btn> -->
                <v-img
                  :src="getIconImg(idx)"
                  max-width="30px"
                  :disabled="editFlag !== 0 && editLocationMode !== 1"
                  @click="iconEdit(idx)"
                ></v-img>
              </span>
            </td>
            <td v-if="!isLoading(idx)">
              <span v-if="item.address">
                <v-btn
                  fab
                  outlined
                  x-small
                  color="success"
                  :disabled="editFlag !== 0 && editLocationMode !== 1"
                  @click="deletePoint(idx)"
                >
                  <v-icon small>clear</v-icon>
                </v-btn>
              </span>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-col>
    <!-- 登録中の説明 -->
    <v-row class="pl-4 py-2 ma-0">
      <span class="vc-info">{{ text.info }}</span>
    </v-row>
  </v-card>
</template>
<script>
import mixin from "./../../lib/mixin.js";
import WebStorage from "./../../lib/webStorage.js";
import PageLog from "./../../lib/pageLog.js";
export default {
  name: "vc-point",
  mixins: [mixin],
  data() {
    return {
      pointRegist: [],
      iconImg: [],
      rules: [
        (v) =>
          v.length <= this.maxLength ||
          this.maxLength + "字以内で登録してください。",
      ],
      iconUrl: "/kawabou/img/map_icons/",
      text: {
        registrationPoint: "登録地点",
        help:
          "地点登録すると、地図上にホームアイコンが表示され、" +
          "影響のある河川の水位情報や浸水の影響度合いを見ることができます。",
        info: "「登録」ボタンを押して地点登録を開始します。",
        pointName: "地点名",
        location: "所在地",
        riskInfo: "リスク情報",
        icon: "アイコン",
        relatedOb: "関連観測所",
        delete: "削除",
        registration: "登録",
        add: "追加",
        collection: "リスク判定する",
        uppdate: "リスク再判定",
        rpStateName1: "3時間以内に浸水深50cmになる破堤点取得",
        rpStateName2: "河川毎最大浸水深取得",
        rpStateName3: "河川毎最速到達時間取得",
        rpStateName4: "河川毎最大継続時間取得",
        cancel: "キャンセル",
      },
    };
  },
  /**
   * マウント後イベント
   */
  mounted() {
    this.$log.debug("[VcPoint] mounted()");
    // アクセスログ出力
    PageLog.log({
      page_log: "setting",
      device_sb: this.$store.state.app.mode,
      fc_flg: this.$store.getters["app/isFldCtl"],
    });
    this.init();
    // 初期表示時に有効データの一番上を選択
    let point1 = WebStorage.getPoint1Info();
    let point2 = WebStorage.getPoint2Info();
    let point3 = WebStorage.getPoint3Info();
    let point4 = WebStorage.getPoint4Info();
    let point5 = WebStorage.getPoint5Info();
    let index = 0;
    if (point1) {
      index = 0;
    } else if (point2) {
      index = 1;
    } else if (point3) {
      index = 2;
    } else if (point4) {
      index = 3;
    } else if (point5) {
      index = 4;
    }
    this.$store.commit("viewConfig/setSelectedPoint", index);
  },
  computed: {
    /** 登録地点読み込み日時 */
    editWebStorageDate: {
      get() {
        return this.$store.state.map.editWebStorageDate;
      },
    },
    /** 登録地編集モード [0:未編集, 1:地図選択, 2:登録確認] */
    editLocationMode: {
      get() {
        return this.$store.state.map.editLocationMode;
      },
    },
    /** 選択地点番号 */
    selectedPoint: {
      get() {
        return this.$store.state.viewConfig.selectedPoint;
      },
    },
    /** 登録中フラグ */
    editFlag: {
      get() {
        return this.$store.state.map.editFlag;
      },
    },
    /** 地点登録番号 */
    registPointNum: {
      get() {
        return this.$store.state.viewConfig.registPointNum;
      },
    },
    /** LocalStrageの初期表示情報(default) */
    localStrageDefault: {
      get() {
        return JSON.parse(localStorage.getItem("default"));
      },
    },
    /** 登録地点名の最大文字数 */
    maxLength: {
      get() {
        return this.$store.state.app.config.registConfig
          .maxRegistPointNameLength;
      },
    },
    /** 地点登録状況 */
    registPointState: {
      get() {
        return this.$store.state.Telemeter.registPointState;
      },
    },
    /** プログレスの値 */
    progressValue: {
      get() {
        let val = (this.$store.state.Telemeter.registPointState / 4) * 100;
        return val;
      },
    },
  },
  watch: {
    /** 地図の登録地点が読み直された場合、コンポーネントも再表示 */
    editWebStorageDate() {
      this.$log.debug("[VcPoint] watch(editWebStorageDate)");
      this.init();
    },
  },
  methods: {
    /** 表示項目初期化 */
    init() {
      this.$log.debug("[VcPoint] init()");
      // webストレージから表示情報を取得
      let point1 = WebStorage.getPoint1Info();
      this.$log.debug("[VcPoint] init point1");
      this.$log.dir(point1);
      let point2 = WebStorage.getPoint2Info();
      this.$log.debug("[VcPoint] init point2");
      this.$log.dir(point2);
      let point3 = WebStorage.getPoint3Info();
      this.$log.debug("[VcPoint] init point3");
      this.$log.dir(point3);
      let point4 = WebStorage.getPoint4Info();
      this.$log.debug("[VcPoint] init point4");
      this.$log.dir(point4);
      let point5 = WebStorage.getPoint5Info();
      this.$log.debug("[VcPoint] init point5");
      this.$log.dir(point5);

      this.pointRegist = [
        {
          name: point1 ? point1.name : "",
          address: point1 ? point1.address : "",
          risk: point1 ? point1.risk : "",
          point: point1,
        },
        {
          name: point2 ? point2.name : "",
          address: point2 ? point2.address : "",
          risk: point2 ? point2.risk : "",
          point: point2,
        },
        {
          name: point3 ? point3.name : "",
          address: point3 ? point3.address : "",
          risk: point3 ? point3.risk : "",
          point: point3,
        },
        {
          name: point4 ? point4.name : "",
          address: point4 ? point4.address : "",
          risk: point4 ? point4.risk : "",
          point: point4,
        },
        {
          name: point5 ? point5.name : "",
          address: point5 ? point5.address : "",
          risk: point5 ? point5.risk : "",
          point: point5,
        },
      ];
      // アイコンの読み直し
      if (point1 && point1.iconImg) {
        this.iconImg[0] = this.iconUrl + point1.iconImg;
      } else {
        this.iconImg[0] = this.iconUrl + "rp_base_navy.svg";
      }
      if (point2 && point2.iconImg) {
        this.iconImg[1] = this.iconUrl + point2.iconImg;
      } else {
        this.iconImg[1] = this.iconUrl + "rp_base_navy.svg";
      }
      if (point3 && point3.iconImg) {
        this.iconImg[2] = this.iconUrl + point3.iconImg;
      } else {
        this.iconImg[2] = this.iconUrl + "rp_base_navy.svg";
      }
      if (point4 && point4.iconImg) {
        this.iconImg[3] = this.iconUrl + point4.iconImg;
      } else {
        this.iconImg[3] = this.iconUrl + "rp_base_navy.svg";
      }
      if (point5 && point5.iconImg) {
        this.iconImg[4] = this.iconUrl + point5.iconImg;
      } else {
        this.iconImg[4] = this.iconUrl + "rp_base_navy.svg";
      }
    },
    /** 登録ボタン押下 */
    regist(index, name, flag) {
      this.$log.debug(
        "[VcPoint] regist(" + index + "," + name + "," + flag + ")"
      );
      // アクセスログ出力
      PageLog.log({
        page_log: "pointregi",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });

      switch (index) {
        case 0:
          if (name === "") {
            this.$log.debug("[VcPoint] name 1 change to default.");
            name =
              this.$store.state.app.config.registConfig.defaultRegistPointName +
              "１";
          }
          break;
        case 1:
          if (name === "") {
            this.$log.debug("[VcPoint] name 2 change to default.");
            name =
              this.$store.state.app.config.registConfig.defaultRegistPointName +
              "２";
          }
          break;
        case 2:
          if (name === "") {
            this.$log.debug("[VcPoint] name 3 change to default.");
            name =
              this.$store.state.app.config.registConfig.defaultRegistPointName +
              "３";
          }
          break;
        case 3:
          if (name === "") {
            this.$log.debug("[VcPoint] name 4 change to default.");
            name =
              this.$store.state.app.config.registConfig.defaultRegistPointName +
              "４";
          }
          break;
        case 4:
          if (name === "") {
            this.$log.debug("[VcPoint] name 5 change to default.");
            name =
              this.$store.state.app.config.registConfig.defaultRegistPointName +
              "５";
          }
          break;
      }
      this.editDate = this.editWebStorageDate;
      this.$store.commit("map/setEditLocationMode", 1);
      this.$store.commit("viewConfig/setSelectedPointName", name);
      this.$store.commit("viewConfig/setSelectedPoint", index);
      this.$store.commit("viewConfig/setRegistPointNum", index);
      this.$store.commit("map/setEditFlag", flag);
    },
    /** 地点名変更時 */
    changePointName(index) {
      this.$log.debug("[VcPoint] changePointName(" + index + ")");
      switch (index) {
        case 0:
          this.$log.debug("[VcPoint] changePointName index == 0");
          var point1 = WebStorage.getPoint1Info();
          point1 = point1 ? point1 : {};
          if (this.pointRegist[index].name === "") {
            point1.name =
              this.$store.state.app.config.registConfig.defaultRegistPointName +
              "１";
          } else {
            point1.name = this.pointRegist[index].name;
          }
          WebStorage.setPoint1Info(point1);
          break;
        case 1:
          this.$log.debug("[VcPoint] changePointName index == 1");
          var point2 = WebStorage.getPoint2Info();
          point2 = point2 ? point2 : {};
          if (this.pointRegist[index].name === "") {
            point2.name =
              this.$store.state.app.config.registConfig.defaultRegistPointName +
              "２";
          } else {
            point2.name = this.pointRegist[index].name;
          }
          WebStorage.setPoint2Info(point2);
          break;
        case 2:
          this.$log.debug("[VcPoint] changePointName index == 2");
          var point3 = WebStorage.getPoint3Info();
          point3 = point3 ? point3 : {};
          if (this.pointRegist[index].name === "") {
            point3.name =
              this.$store.state.app.config.registConfig.defaultRegistPointName +
              "３";
          } else {
            point3.name = this.pointRegist[index].name;
          }
          WebStorage.setPoint3Info(point3);
          break;
        case 3:
          this.$log.debug("[VcPoint] changePointName index == 3");
          var point4 = WebStorage.getPoint4Info();
          point4 = point4 ? point4 : {};
          if (this.pointRegist[index].name === "") {
            point4.name =
              this.$store.state.app.config.registConfig.defaultRegistPointName +
              "４";
          } else {
            point4.name = this.pointRegist[index].name;
          }
          WebStorage.setPoint4Info(point4);
          break;
        case 4:
          this.$log.debug("[VcPoint] changePointName index == 4");
          var point5 = WebStorage.getPoint5Info();
          point5 = point5 ? point5 : {};
          if (this.pointRegist[index].name === "") {
            point5.name =
              this.$store.state.app.config.registConfig.defaultRegistPointName +
              "５";
          } else {
            point5.name = this.pointRegist[index].name;
          }
          WebStorage.setPoint5Info(point5);
          break;
      }
      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },
    /** リスク情報の収集 */
    collectionRisk(index, isRisk) {
      this.$log.debug("[VcPoint] collectionRisk(" + index + "," + isRisk + ")");

      this.$store.commit("viewConfig/setSelectedPoint", index);
      this.$store.commit("viewConfig/setRegistPointNum", index);

      // 確認ダイアログ
      this.$store.commit("viewConfig/setRiskFlg", 1);
    },
    /** 観測所追加時 */
    addTm(index) {
      this.$log.debug("[VcPoint] addTm(" + index + ")");
      // アクセスログ出力
      PageLog.log({
        page_log: "obsadd",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.$store.commit("map/setEditTmMode", 1);
      this.$store.commit("viewConfig/setSelectedPoint", index);
    },
    /** 地点選択時 */
    selectPoint(index) {
      this.$log.debug("[VcPoint] selectPoint(" + index + ")");
      this.$store.commit("viewConfig/setSelectedPoint", index);
    },
    /** 地点削除時 */
    deletePoint(index) {
      this.$log.debug("[VcPoint] deletePoint(" + index + ")");

      this.$store.commit("viewConfig/setSelectedPoint", index);
      this.$store.commit("viewConfig/setRegistPointNum", index);

      // 確認ダイアログ
      this.$store.commit("viewConfig/setDeleteFlg", 1);
    },
    /** アイコン変更 */
    iconEdit(index) {
      this.$log.debug("[VcPoint] iconEdit(" + index + ")");
      this.$store.commit("viewConfig/setSelectedPoint", index);
      this.$store.commit("viewConfig/setIconEditFlg", 1);
    },
    /** 読込中 */
    isLoading(idx) {
      if (
        this.editFlag !== 0 &&
        this.editLocationMode !== 1 &&
        idx === this.registPointNum
      ) {
        return true;
      } else {
        return false;
      }
    },
    /** 登録キャンセル */
    registCancel(index) {
      this.$log.debug("[VcPoint] registCancel(" + index + ")");

      // ステータスをクリア
      this.$store.commit("map/setEditLocationMode", 0);
      this.$store.commit("map/setEditTmMode", 0);
      this.$store.commit("map/setEditFlag", 0);

      // 地点登録状況に9:キャンセルを設定
      this.$store.commit("Telemeter/setRegistPointState", 9);

      // this.$store.dispatch("Telemeter/registCancel");
    },
    /** アイコン画像取得 */
    getIconImg(idx) {
      return this.iconImg[idx];
    },
  },
};
</script>

<style lang="scss" scoped>
.sub-head {
  font-size: 0.8rem;
}
.point-data {
  cursor: pointer;
}

.vc-th-point {
  width: 100px;
}
.vc-th-location {
  width: 100px;
}
.vc-th-riskInfo {
  width: 50px;
}
.vc-th-icon {
  width: 80px;
}
.vc-th-delete {
  width: 60px;
}

.vc-info {
  font-size: 0.9rem;
}

.vc-item-name {
  font-size: 0.9rem;
}

.vc-td-loading {
  display: flex;
  align-items: center;
  .vc-td-item-loading {
    display: flex;
    justify-content: flex-end;
    width: 150px;
  }
  .vc-td-item-tooltip {
    display: flex;
    flex-direction: row;
  }
  .vc-td-item-cancel {
    flex: 1;
  }
}
</style>
